// yadsScheduleReducer.js
import {
  POST_YADS_SCHEDULE_REQUEST,
  POST_YADS_SCHEDULE_SUCCESS,
  POST_YADS_SCHEDULE_FAILURE,
  POST_YADS_SCHEDULE_RESET,
} from '../../../Constants/actionTypes';

const initial = {
  loading: false,
  result: null,
  error: '',
};

const yadsScheduleReducer = (state = initial, action) => {
  switch (action.type) {
    case POST_YADS_SCHEDULE_REQUEST:
      return { ...state, loading: true, error: '' };
    case POST_YADS_SCHEDULE_SUCCESS:
      return { loading: false, result: action.payload, error: '' };
    case POST_YADS_SCHEDULE_FAILURE:
      return { loading: false, result: null, error: action.payload };
    case POST_YADS_SCHEDULE_RESET:
      return initial;
    default:
      return state;
  }
};

export default yadsScheduleReducer;
